export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8565.8fa337a0.jpg";